import {fileApi} from "../api/api";
import {FileMetadata, ModelFile} from "../gen/api";

class FileService {
  uploadFile(form: FileMetadata, file: File): Promise<FileMetadata> {
    return fileApi.uploadFile(form, file)
    .then(response => {
      if (response.status === 201) return response.data;
      else throw new Error("Rest call failed with code " + response.status)
    });
  }

  downloadFile(id: string): Promise<ModelFile> {
    return fileApi.downloadFile(id).then(
        response => {
          if (response.status === 200) return response.data;
          else throw new Error("Rest call failed with code " + response.status)
        }
    )
  }

  deleteFile(id: string): Promise<void> {
    return fileApi.deleteFile(id).then(
        response => {
          if (response.status === 204) return response.data;
          else throw new Error("Rest call failed with code " + response.status)
        }
    )
  }

}

export default new FileService();
